import { AnimatedOutlet } from "@/app/components/animated-outlet";
import { AfgerondDossierList } from "@/features/dossier-balk/components/afgerond-dossier-list";
import { Toaster } from "@/shared/components";
import { ErrorBoundary, ErrorDisplay } from "@/shared/components/error";

export default function AfgerondPage() {
    return (
        <ErrorBoundary
            fallback={(error, reset) => (
                <ErrorDisplay error={error} variant="section" title="Fout bij het laden van afgeronde dossiers" onRetry={reset} />
            )}
        >
            <div className="flex flex-1 flex-col">
                <AfgerondDossierList />
                <div className="relative flex w-full flex-1">
                    <div className="bg-accent-gray-subtle absolute inset-0">
                        <div className="relative flex h-full w-full">
                            <AnimatedOutlet />
                        </div>
                    </div>
                </div>
            </div>
            <Toaster />
        </ErrorBoundary>
    );
}
